/**
 * The money of one TSR line, as /tsr/submit receives it.
 *
 * lineWithFileDiscount — a file that states each line's discount (POS "Sales By
 * Items") is the authority. The screen's own discount check only recognises a
 * discount when the menu price equals the file's price; without this, every
 * other line was booked at Gross and its discount vanished.
 *
 * notInMenuMoney — a "Not in Menu" line is revenue too, booked at what was
 * actually charged (the Net), not the Gross before discount.
 */
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function lineWithFileDiscount({ quantity, unitPrice, fileDiscount }) {
  const qty = Number(quantity) || 0;
  const amount = round2(qty * (Number(unitPrice) || 0));
  const discount = Math.min(Math.max(0, round2(fileDiscount)), amount);
  return {
    amount,
    discount_amount: discount,
    unit_price: qty > 0 ? round2((amount - discount) / qty) : 0,
    discount_percentage: amount > 0 ? round2((discount / amount) * 100) : 0,
  };
}

export function notInMenuMoney({ quantity, unitPrice, amount, netAmount }) {
  const qty = Number(quantity) || 0;
  const price = Number(unitPrice) || 0;
  const gross = Number(amount) || qty * price;
  const net = Number(netAmount);
  if (netAmount !== undefined && netAmount !== null && netAmount !== '' && Number.isFinite(net) && net >= 0 && net <= gross + 0.005) {
    return { amount: round2(net), unitPrice: qty > 0 ? round2(net / qty) : price };
  }
  return { amount: gross, unitPrice: price };
}
